import React from 'react';
import './styles.css';

class LoadingComponent extends React.Component {

    render() {
        const {isLoading} = this.props;
        return (
            <div>
                {isLoading &&
                    <div className='loadingContainer'>
                        <img className='loadingImage' src='/assets/epic-loading.gif'/>
                        <p className='sectionDescription'>Loading...</p>
                    </div>
                }
            </div>
        );
    }

}

export default LoadingComponent;


// WEBPACK FOOTER //
// ./src/components/Loading/index.js